module.exports = __webpack_public_path__ + "Roboto-Bold.56a76a220d9c9765946d.ttf";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-Bold.ttf
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Bold.ttf
// module chunks = 5